import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';

/**
 * Sujet pour lancer récupération des infos capteur
 */
export const notifProvisioningSubject = new Subject<void>();

@Injectable({ providedIn: 'root' })
export class IotNotificationHandler {
  private readonly notificationProvisioningType = 'provisioning';

  /**
   * Gère les notifications liées à la partie IoT
   */
  handleNotification(notification): Observable<null> {
    if (notification.type === this.notificationProvisioningType) {
      notifProvisioningSubject.next();
    }
    return of();
  }
}
